<template>
  <div class="wx-push-notice-page">
    <a-card :bordered="false" class="search-card">
      <a-form layout="inline">
        <!-- <a-form-item label="推送类型">
          <a-select v-model="query.pushType" placeholder="请选择" allow-clear style="width: 140px">
            <a-select-option :value="1">批量推送</a-select-option>
            <a-select-option :value="2">指定推送</a-select-option>
          </a-select>
        </a-form-item> -->
        <a-form-item label="模板名称">
          <a-input v-model="query.title" placeholder="请输入" allow-clear />
        </a-form-item>
        <a-form-item label="推送状态">
          <a-select v-model="query.pushState" placeholder="请选择" allow-clear style="width: 140px">
            <a-select-option :value="0">处理中</a-select-option>
            <a-select-option :value="1">失败</a-select-option>
            <a-select-option :value="2">完成(全部成功)</a-select-option>
            <a-select-option :value="3">完成(部分成功)</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="推送时间">
          <a-range-picker v-model="queryTimeRange" show-time value-format="YYYY-MM-DD HH:mm:ss" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="handleSearch">查询</a-button>
          <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
          <a-button style="margin-left: 8px" type="danger" :disabled="selectedRowKeys.length === 0" @click="handleBatchDelete">删除</a-button>
          <a-button style="margin-left: 8px" type="primary" @click="openSendModal">发送通知</a-button>
        </a-form-item>
      </a-form>
    </a-card>

    <a-card :bordered="false">
      <a-table
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :loading="loading"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :rowKey="(record, index) => index"
        @change="handleTableChange"
      >
        <template slot="pushState" slot-scope="text">
          <a-tag :color="getPushStateColor(text)">{{ getPushStateText(text) }}</a-tag>
        </template>
        <template slot="action" slot-scope="text, record">
          <a @click="openDetailModal(record)">推送详情</a>
        </template>
      </a-table>
    </a-card>

    <a-modal
      title="发送微信通知"
      :visible="sendModalVisible"
      :confirm-loading="sendLoading"
      ok-text="发送通知"
      @ok="handleSend"
      @cancel="sendModalVisible = false"
      width="700px"
    >
      <a-form-model :model="sendForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
        <a-form-model-item label="模版选择" required>
          <a-select v-model="sendForm.id" placeholder="请选择" @change="handleTemplateChange">
            <a-select-option v-for="item in templateOptions" :key="item.id" :value="item.id">
         {{ item.title || '-' }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <!-- <a-form-model-item label="模板名称" required>
          <a-input v-model="sendForm.title" disabled />
        </a-form-model-item> -->
        <a-form-model-item label="模板内容">
          <a-textarea :value="templateContentWithVars" :rows="6" disabled />
        </a-form-model-item>
        <a-form-model-item label="停水类型" required>
          <a-auto-complete
            v-model="sendForm.outageType"
            :data-source="waterCutTypeOptions"
            placeholder="请选择或输入停水类型"
            allow-clear
            :filter-option="filterWaterCutTypeOption"
            :dropdown-style="{ zIndex: 1100 }"
            :get-popup-container="(trigger) => trigger.parentNode"
          />
        </a-form-model-item>
        <a-form-model-item label="停水时间" required>
          <a-input
          v-model="sendForm.outageTime"
          placeholder="请输入停水时间"
          /> 
        </a-form-model-item>
        <a-form-model-item label="停水区域" required>
          <a-textarea v-model="sendForm.outageArea" :rows="6" placeholder="请输入" />
        </a-form-model-item>
      </a-form-model>
      <div class="send-tip">注：确定发送通知后，会将此消息发送给所有关注服务号的用户。</div>
    </a-modal>

    <a-modal
      title="推送详情"
      :visible="detailModalVisible"
      :footer="null"
      @cancel="detailModalVisible = false"
      width="980px"
    >
      <div class="detail-search">
        <a-form layout="inline">
          <a-form-item label="OpenID">
            <a-input v-model="detailQuery.openId" placeholder="请输入" allow-clear />
          </a-form-item>
          <a-form-item label="推送状态">
            <a-select v-model="detailQuery.pushUserState" placeholder="请选择" allow-clear style="width: 140px">
              <a-select-option :value="0">处理中</a-select-option>
              <a-select-option :value="1">失败</a-select-option>
              <a-select-option :value="2">成功</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="handleDetailSearch">查询</a-button>
            <a-button style="margin-left: 8px" @click="handleDetailReset">重置</a-button>
          </a-form-item>
        </a-form>
      </div>
      <a-table
        :columns="detailColumns"
        :data-source="detailList"
        :pagination="detailPagination"
        :loading="detailLoading"
        :rowKey="(record, index) => index"
        @change="handleDetailTableChange"
      >
        <template slot="pushUserState" slot-scope="text">
          <a-tag :color="getUserStateColor(text)">{{ getUserStateText(text) }}</a-tag>
        </template>
      
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import storage from 'store'
import { getPushMsgList, getPushMsgDetails, deletePushMsg, sendWxPushMsg, selectWxTemplateByTenantId } from '@/api/serviceConfig'

export default {
  name: 'WxPushNoticePage',
  data() {
    return {
      loading: false,
      list: [],
      query: {
        pushType: undefined,
        title: '',
        pushState: undefined,
        startTime: undefined,
        endTime: undefined
      },
      queryTimeRange: [],
      selectedRowKeys: [],
      columns: [
        // { title: '推送类型', dataIndex: 'pushTypeName', key: 'pushTypeName', width: 120 },
        { title: '模板名称', dataIndex: 'title', key: 'title', width: 160 },
        { title: '推送内容', dataIndex: 'pushMsg', key: 'pushMsg', ellipsis: true },
        { title: '推送状态', dataIndex: 'pushState', key: 'pushState', width: 140, scopedSlots: { customRender: 'pushState' } },
        { title: '应接收人数', dataIndex: 'pushNum', key: 'pushNum', width: 110 },
        { title: '成功人数', dataIndex: 'pushSuccessNum', key: 'pushSuccessNum', width: 100 },
        { title: '失败人数', dataIndex: 'pushFailNum', key: 'pushFailNum', width: 100 },
        { title: '推送时间', dataIndex: 'pushTime', key: 'pushTime', width: 180 },
        { title: '操作', key: 'action', width: 100, scopedSlots: { customRender: 'action' } }
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => `共 ${total} 条记录`
      },
      sendModalVisible: false,
      sendLoading: false,
      templateOptions: [],
      waterCutTypeOptions: ['紧急停水', '计划停水', '延长时段停水'],
      sendForm: {
        id: undefined,
        templateId: undefined,
        title: '',
        content: '',
        example: '',
        createTime: '',
        isApply: 0,
        outageType: '',
        outageTime: '',
        outageArea: ''
      },
      detailModalVisible: false,
      detailLoading: false,
      currentPushLogId: undefined,
      detailQuery: {
        openId: '',
        pushUserState: undefined
      },
      detailColumns: [
        { title: 'OpenID', dataIndex: 'openId', key: 'openId', width: 220 },
        { title: '推送状态', dataIndex: 'pushUserState', key: 'pushUserState', width: 120, scopedSlots: { customRender: 'pushUserState' } },
        { title: '耗时', dataIndex: 'timeConsumer', key: 'timeConsumer', width: 100 },
        { title: '推送时间', dataIndex: 'updateTime', key: 'updateTime', width: 180 }
      ],
      detailList: [],
      detailPagination: {
        current: 1,
        pageSize: 5,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => `共 ${total} 条记录`
      }
    }
  },
  computed: {
    // 替换微信模板变量后的内容
    templateContentWithVars () {
      let content = this.sendForm.content || ''
      const { outageType, outageTime, outageArea } = this.sendForm
      // 替换微信模板变量
      if (outageType) {
        content = content.replace(/\{\{keyword1\.DATA\}\}/g, outageType)
      }
      if (outageTime) {
        content = content.replace(/\{\{keyword2\.DATA\}\}/g, outageTime)
      }
      if (outageArea) {
        content = content.replace(/\{\{keyword3\.DATA\}\}/g, outageArea)
      }
      return content
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    filterWaterCutTypeOption (input, option) {
      if (input === undefined || input === null || String(input).trim() === '') return true
      const q = String(input).trim()
      let text = ''
      if (typeof option === 'string') {
        text = option
      } else if (option && typeof option === 'object') {
        text = option.value != null ? String(option.value) : (option.text != null ? String(option.text) : '')
      }
      return text.indexOf(q) >= 0
    },
    loadList() {
      this.loading = true
      const params = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        pushType: this.query.pushType,
        pushState: this.query.pushState,
        title: this.query.title || undefined,
        startTime: this.query.startTime,
        endTime: this.query.endTime
      }
      getPushMsgList(params).then(res => {
        if (res.code === 0) {
          this.list = res.rows ||[]
          this.pagination.total = Number(res.total  || 0)
        } else {
          this.$message.error(res.message || '获取推送日志失败')
        }
      }).catch(() => {
        this.$message.error('获取推送日志失败')
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch() {
      this.query.startTime = this.queryTimeRange?.[0]
      this.query.endTime = this.queryTimeRange?.[1]
      this.pagination.current = 1
      this.loadList()
    },
    handleReset() {
      this.query = {
        pushType: undefined,
        title: '',
        pushState: undefined,
        startTime: undefined,
        endTime: undefined
      }
      this.queryTimeRange = []
      this.pagination.current = 1
      this.loadList()
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadList()
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    handleBatchDelete() {
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$confirm({
        title: '确认删除',
        content: `确定删除选中的 ${this.selectedRowKeys.length} 条推送日志吗？`,
        onOk: () => {
          deletePushMsg({ ids: this.selectedRowKeys }).then(res => {
            if (res.code === 0) {
              this.$message.success('删除成功')
              this.selectedRowKeys = []
              this.loadList()
            } else {
              this.$message.error(res.message || '删除失败')
            }
          }).catch(() => {
            this.$message.error('删除失败')
          })
        }
      })
    },
    openSendModal() {
      this.sendModalVisible = true
      this.sendForm = {
        id: undefined,
        templateId: undefined,
        title: '',
        content: '',
        example: '',
        createTime: '',
        isApply: 0,
        outageType: '',
        outageTime: '',
        outageArea: ''
      }
      this.loadTemplateOptions()
    },
    loadTemplateOptions() {
      selectWxTemplateByTenantId({ ispage: 1, pageNum: 1, pageSize: 100 }).then(res => {
        if (res.code === 0) {
          this.templateOptions = res.rows || res.data?.rows || res.data || []
        } else {
          this.templateOptions = []
        }
      }).catch(() => {
        this.templateOptions = []
      })
    },
    handleTemplateChange(val) {
      const current = this.templateOptions.find(item => item.id === val)
      this.sendForm.templateId = current?.templateId || ''
      this.sendForm.title = current?.title || current?.templateName || ''
      this.sendForm.content = current?.content || ''
      this.sendForm.example = current?.example || ''
      this.sendForm.createTime = current?.createTime || ''
      this.sendForm.isApply = Number(current?.isApply || 0)
    },
    handleSend() {
      if (!this.sendForm.id || !this.sendForm.title || !this.sendForm.outageType || !this.sendForm.outageTime || !this.sendForm.outageArea) {
        this.$message.warning('请完整填写发送参数')
        return
      }
      this.sendLoading = true
      const payload = {
        eventName: this.sendForm.title,
        id: this.sendForm.id,
        lineId: 0,
        tenantId: storage.get('tenantId') || '',
        userId: storage.get('userId') || '',
        waterCutRegion: this.sendForm.outageArea,
        waterCutTime: this.sendForm.outageTime,
        waterCutType: this.sendForm.outageType
      }
      sendWxPushMsg(payload).then(res => {
        if (res.code === 0) {
          this.$message.success('发送成功')
          this.sendModalVisible = false
          this.loadList()
        } else {
          this.$message.error(res.message || '发送失败')
        }
      }).catch(() => {
        this.$message.error('发送失败')
      }).finally(() => {
        this.sendLoading = false
      })
    },
    openDetailModal(record) {
      this.currentPushLogId = record.id 
      if (!this.currentPushLogId) {
        this.$message.warning('当前记录缺少推送日志ID，无法查询详情')
        return
      }
      this.detailModalVisible = true
      this.detailQuery = {
        openId: '',
        pushUserState: undefined
      }
      this.detailPagination.current = 1
      this.loadDetailList()
    },
    loadDetailList() {
      if (!this.currentPushLogId) return
      this.detailLoading = true
      const params = {
        wxPushLogId: this.currentPushLogId,
        pageNum: this.detailPagination.current,
        pageSize: this.detailPagination.pageSize,
        openId: this.detailQuery.openId || undefined,
        pushUserState: this.detailQuery.pushUserState
      }
      getPushMsgDetails(params).then(res => {
        if (res.code === 0) {
          this.detailList = res.rows
          this.detailPagination.total = Number(res.total || res.data?.total || 0)
        } else {
          this.$message.error(res.msg || '获取推送详情失败')
        }
      }).catch(() => {
        this.$message.error('获取推送详情失败')
      }).finally(() => {
        this.detailLoading = false
      })
    },
    handleDetailSearch() {
      this.detailPagination.current = 1
      this.loadDetailList()
    },
    handleDetailReset() {
      this.detailQuery = {
        openId: '',
        pushUserState: undefined
      }
      this.detailPagination.current = 1
      this.loadDetailList()
    },
    handleDetailTableChange(pagination) {
      this.detailPagination.current = pagination.current
      this.detailPagination.pageSize = pagination.pageSize
      this.loadDetailList()
    },
    getPushStateText(val) {
      const map = {
        0: '处理中',
        1: '失败',
        2: '已完成(全部成功)',
        3: '已完成(部分成功)'
      }
      return map[val] || '-'
    },
    getPushStateColor(val) {
      const map = {
        0: 'blue',
        1: 'red',
        2: 'green',
        3: 'orange'
      }
      return map[val] || 'default'
    },
    getUserStateText(val) {
      const map = {
        0: '队列中',
        1: '失败',
        2: '成功'
      }
      return map[val] || '-'
    },
    getUserStateColor(val) {
      const map = {
        0: 'blue',
        1: 'red',
        2: 'green'
      }
      return map[val] || 'default'
    }
  }
}
</script>

<style lang="less" scoped>


.search-card {
  margin-bottom: 16px;
}

.detail-search {
  margin-bottom: 12px;
}

.send-tip {
  color: rgba(0, 0, 0, 0.45);
  text-align: center;
  margin-top: 12px;
}
</style>
